function sendAjaxForm(_form){
	var _data = new FormData(_form);
	$.ajax({
		url: '/form-ajax',
		dataType: 'json',
		type: 'POST',
		contentType: false,
		processData: false,
		data: _data,
		success: function (data) {
			$('#popup').removeClass('popup_active');
			$('#popup-thanks').addClass('popup_active');
		},
		error: function (data) {
			console.log(data);
			$('#popup').removeClass('popup_active');
			$('#popup-thanks').addClass('popup_active');
		}
	});
}

$(function() {
	$('.form').submit(function (e) {
		e.preventDefault();
		sendAjaxForm(this);
	});
});
